import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModelsUser } from "../../../app/api/model/models";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { FormsModule } from "@angular/forms";
import { InputTextModule } from "primeng/inputtext";
import { Ripple } from 'primeng/ripple';
import { TranslocoModule } from '@jsverse/transloco';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ModelsCompanyPosition } from '../../api/model/models';

@Component({
  selector: 'app-hr-employee-form',
  template: `
    <p-dialog [visible]="visible" (visibleChange)="onVisibleChange($event)" [style]="{width: '450px'}" [header]="'Employee Details' | transloco" [modal]="true"
              styleClass="p-fluid">
      <ng-template pTemplate="content">
        <div class="flex flex-col gap-4 mt-2">
          <div class="flex flex-col gap-2">
            <label for="first_name" class="font-semibold">{{ 'First Name' | transloco }}</label>
            <input type="text" pInputText id="first_name" [(ngModel)]="employee.first_name" required autofocus/>
          </div>
          <div class="flex flex-col gap-2">
            <label for="last_name" class="font-semibold">{{ 'Last Name' | transloco }}</label>
            <input type="text" pInputText id="last_name" [(ngModel)]="employee.last_name" required/>
          </div>
          <div class="flex flex-col gap-2">
            <label for="phone" class="font-semibold">{{ 'Phone' | transloco }}</label>
            <input type="text" pInputText id="phone" [(ngModel)]="employee.phone" required/>
          </div>
          <div class="flex flex-col gap-2">
            <label for="positions" class="font-semibold">{{ 'Position' | transloco }}</label>
            <p-multiSelect 
              id="positions" 
              [options]="positions" 
              [(ngModel)]="employee.positions" 
              optionLabel="name" 
              dataKey="id"
              [placeholder]="'Select Positions' | transloco"
              display="chip"
              appendTo="body"
            />
          </div>
          <!-- <div class="flex flex-col gap-2">
            <label for="role" class="font-semibold">{{ 'Role' | transloco }}</label>
            <p-select 
              id="role" 
              [options]="roles" 
              [(ngModel)]="employee.role" 
              [disabled]="!canEditRole"
              optionLabel="label"
              optionValue="value"
              appendTo="body">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                {{ selectedOption.label | transloco }}
              </ng-template>
              <ng-template pTemplate="item" let-option>
                {{ option.label | transloco }}
              </ng-template>
            </p-select>
          </div> -->
          <div class="flex flex-row items-center justify-between mt-2">
            <label for="wa_opt_in" class="font-semibold">{{ 'Confirm privacy policy and receive messages on WhatsApp' | transloco }}</label>
            <p-toggleSwitch 
              id="wa_opt_in" 
              [(ngModel)]="employee.wa_opt_in" 
            />
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="footer">
        <button pButton pRipple [label]="'Cancel' | transloco" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
        <button pButton pRipple [label]="'Save' | transloco" icon="pi pi-check" class="p-button-text" (click)="saveEmployee()"
                [disabled]="!employee.first_name || !employee.last_name || !employee.phone"></button>
      </ng-template>
    </p-dialog>
  `,
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    FormsModule,
    InputTextModule,
    Ripple,
    TranslocoModule,
    MultiSelectModule,
    SelectModule,
    ToggleSwitchModule
  ]
})
export class HrEmployeesForm {
  @Input() visible = false;
  @Input() employee: ModelsUser = {} as ModelsUser;
  @Input() positions: ModelsCompanyPosition[] = [];
  @Input() canEditRole = false;
  @Output() onSave = new EventEmitter<ModelsUser>();
  @Output() onCancel = new EventEmitter<void>();

  roles = [
    { label: 'Employee', value: 'employee' },
    { label: 'Manager', value: 'manager' },
    { label: 'Owner', value: 'owner' }
  ];

  onVisibleChange(isVisible: boolean) {
    if (!isVisible) {
      this.hideDialog();
    }
  }

  hideDialog() {
    this.onCancel.emit();
  }

  saveEmployee() {
    this.onSave.emit(this.employee);
  }
}
